const QUICKSHIP_FACET_FILTER = 'is_in_stock:true';

const removeQuickshipFacet = filters =>
  [filters]
    .flat(Infinity)
    .filter(Boolean)
    .filter(item => item !== QUICKSHIP_FACET_FILTER);

export default removeQuickshipFacet;
